import { I18n, createI18n } from 'vue-i18n';

const messages = {
  de: {
    message: {
      applicationSubtitle: 'Jetzt Bewerben',
      applicationSubtitle_ai: 'Mit KI in WhatsApp einfach zum passenden Job!',
      welComeTitle: 'Willkommen bei der Bewerbung über WhatsApp',
      step1Title: 'Bewerben mit WhatsApp',
      step1Desc:
        'Starte den Bewerbungsprozess mit Klick auf "Bewerben mit WhatsApp"',
      step1Title_ai: 'Job finden mit WhatsApp',
      step1Desc_ai:
        'Starte deine Jobsuche mit Klick auf "Job finden mit WhatsApp"',
      step2Title: 'Einwilligung in die Nutzung von WhatsApp',
      step2Desc:
        'Willige auf der nächsten Seite in die Nutzung von WhatsApp als Kommunikationskanal ein und stimme unseren Nutzungsbedingungen zu',
      step3Title: 'Öffne WhatsApp',
      step3Desc: 'Scanne den QR-Code oder öffne WhatsApp Desktop',
      step3Desc_mobile: 'WhatsApp öffnet sich automatisch',
      step3Desc_ai_mobile: 'WhatsApp öffnet sich automatisch',
      step4Title: 'Starte die Bewerbung in WhatsApp',
      step4Desc:
        'Sende die vorgeschriebene Nachricht, um den Bewerbungsprozess zu starten',
      step4Title_ai: 'Finde deinen Job in WhatsApp',
      step4Desc_ai:
        'Sende die vorgeschriebene Nachricht und starte die Unterhaltung',
      applyBtn: 'Bewerben mit WhatsApp',
      applyBtn_ai: 'Job finden mit WhatsApp',
      privacyText: 'Mehr erfahren über',
      privacyLink: 'Datenschutzerklärung',
      legalText: 'Lesen Sie',
      legalLink: 'Impressum',
      consentHeader: 'Deine Zustimmung wird benötigt',
      agreeBtn: 'Ich stimme zu',
      successTitle: 'Danke! Starte jetzt in WhatsApp!',
      successDesc_1: 'Scanne jetzt den QR-Code',
      successDesc_2: 'oder',
      successDesc_3: 'öffne die WhatsApp Desktop App',
      successDesc_1_mobile: 'WhatsApp sollte sich automatisch öffnen',
      successDesc_2_mobile: '',
      successDesc_3_mobile:
        'Wenn sich WhatsApp nicht geöffnet hat, klicke auf "Öffne WhatsApp"',
      qrCodeInstruction:
        'Wenn die Anwendung nicht automatisch geladen wurde, scannen Sie den QR-Code mit Ihrem Handy oder klicken Sie auf die Schaltfläche unten.',
      openDesktopBtn: 'Öffne WhatsApp',
      acceptedDisclaimerLbl: 'Zugestimmte Datenschutzerklärung'
    },
  },
  en: {
    message: {
      applicationSubtitle: 'Apply now',
      applicationSubtitle_ai: 'Find the right job easily with AI in WhatsApp!',
      welComeTitle: 'Welcome to the application via WhatsApp',
      step1Title: 'Apply with WhatsApp',
      step1Desc:
        'Start the application process by clicking on "Apply with WhatsApp"',
      step1Title_ai: 'Find a job with WhatsApp',
      step1Desc_ai:
        'Start your job search by clicking on "Find a job with WhatsApp"',
      step2Title: 'Agree to privacy policy',
      step2Desc: 'Accept our privacy policy on the next page',
      step3Title: 'Open WhatsApp',
      step3Desc: 'Scan the QR code or open WhatsApp Desktop',
      step3Desc_mobile: 'WhatsApp opens automatically',
      step3Desc_ai_mobile: 'WhatsApp opens automatically',
      step4Title: 'Start the application in WhatsApp',
      step4Desc: 'Send the prescribed message to start the application process',
      step4Title_ai: 'Find your job on WhatsApp',
      step4Desc_ai: 'Send the prescribed message and start the conversation',
      applyBtn: 'Apply via WhatsApp',
      applyBtn_ai: 'Find a job with WhatsApp',
      privacyText: 'Learn more about',
      privacyLink: 'Privacy Policy',
      legalText: 'Read',
      legalLink: 'imprint',
      consentHeader: 'Your consent is required',
      agreeBtn: 'I agree',
      successTitle: 'Thanks! Start using WhatsApp now!',
      successDesc_1: 'Scan the QR code now',
      successDesc_2: 'or',
      successDesc_3: 'open the WhatsApp desktop app',
      successDesc_1_mobile: 'WhatsApp should open automatically',
      successDesc_2_mobile: '',
      successDesc_3_mobile:
        'If WhatsApp has not opened, click on "Open WhatsApp"',
      qrCodeInstruction:
        'If the application did not load automatically, scan the QR code with your phone or click the button below.',
      openDesktopBtn: 'Open WhatsApp',
      acceptedDisclaimerLbl: 'Accepted Disclaimer'
    },
  },
  hr:{
    message:{
      applicationSubtitle: 'Prijavi se sada',
      applicationSubtitle_ai: 'Pronađite pravi posao lako uz umjetnu inteligenciju u WhatsAppu!',
      welComeTitle: 'Dobrodošli u aplikaciju putem WhatsAppa',
      step1Title: 'Prijavite se putem WhatsAppa',
      step1Desc: 'Započnite proces prijave klikom na "Prijavi se putem WhatsAppa"',
      step1Title_ai: 'Pronađite posao putem WhatsAppa',
      step1Desc_ai: 'Započnite pretragu posla klikom na "Pronađi posao putem WhatsAppa"',
      step2Title: 'Slažem se s pravilima o privatnosti',
      step2Desc: 'Prihvatite našu politiku privatnosti na sljedećoj stranici',
      step3Title: 'Otvori WhatsApp',
      step3Desc: 'Skenirajte QR kod ili otvorite WhatsApp na radnoj površini',
      step3Desc_mobile: 'WhatsApp se automatski otvara',
      step3Desc_ai_mobile: 'WhatsApp se automatski otvara',
      step4Title: 'Pokrenite aplikaciju u WhatsAppu',
      step4Desc: 'Pošaljite propisanu poruku kako biste započeli postupak prijave',
      step4Title_ai: 'Pronađite svoj posao na WhatsAppu',
      step4Desc_ai: 'Pošaljite propisanu poruku i započnite razgovor',
      applyBtn: 'Prijavite se putem WhatsAppa',
      applyBtn_ai: 'Pronađite posao putem WhatsAppa',
      privacyText: 'Saznajte više o',
      privacyLink: 'Pravila o privatnosti',
      legalText: 'Čitaj',
      legalLink: 'otisak',
      consentHeader: 'Vaš pristanak je potreban',
      agreeBtn: 'Slažem se',
      successTitle: 'Hvala! Počnite koristiti WhatsApp odmah!',
      successDesc_1: 'Skenirajte QR kod sada',
      successDesc_2: 'ili',
      successDesc_3: 'otvorite WhatsApp aplikaciju za stolna računala',
      successDesc_1_mobile: 'WhatsApp bi se trebao automatski otvoriti',
      successDesc_2_mobile: '',
      successDesc_3_mobile: 'Ako se WhatsApp nije otvorio, kliknite na "Otvori WhatsApp"',
      qrCodeInstruction: 'Ako se aplikacija nije automatski učitala, skenirajte QR kod telefonom ili kliknite gumb ispod.',
      openDesktopBtn: 'Otvori WhatsApp',
      acceptedDisclaimerLbl: 'Dogovorena politika privatnosti',
    },
  },
  fr: {
    message: {
      applicationSubtitle: 'Postulez maintenant',
      applicationSubtitle_ai: "Trouvez facilement le bon emploi avec l'IA dans WhatsApp !",
      welComeTitle: "Bienvenue sur l'application via WhatsApp",
      step1Title: 'Postulez avec WhatsApp',
      step1Desc: 'Démarrez le processus de candidature en cliquant sur « Postuler avec WhatsApp »',
      step1Title_ai: 'Trouvez un emploi avec WhatsApp',
      step1Desc_ai: "Commencez votre recherche d'emploi en cliquant sur « Trouver un emploi avec WhatsApp »",
      step2Title: 'Accepter la politique de confidentialité',
      step2Desc: 'Acceptez notre politique de confidentialité sur la page suivante',
      step3Title: 'Ouvrez WhatsApp',
      step3Desc: 'Scannez le code QR ou ouvrez WhatsApp Desktop',
      step3Desc_mobile: "WhatsApp s'ouvre automatiquement",
      step3Desc_ai_mobile: "WhatsApp s'ouvre automatiquement",
      step4Title: "Démarrez l'application dans WhatsApp",
      step4Desc: 'Envoyez le message prescrit pour démarrer le processus de candidature',
      step4Title_ai: 'Trouvez votre emploi sur WhatsApp',
      step4Desc_ai: 'Envoyez le message prescrit et démarrez la conversation',
      applyBtn: 'Postulez via WhatsApp',
      applyBtn_ai: 'Trouvez un emploi avec WhatsApp',
      privacyText: 'En savoir plus sur',
      privacyLink: 'politique de confidentialité',
      legalText: 'Lire',
      legalLink: 'imprimer',
      consentHeader: 'Votre consentement est requis',
      agreeBtn: "Je suis d'accord",
      successTitle: 'Merci ! Commencez à utiliser WhatsApp dès maintenant !',
      successDesc_1: 'Scannez le code QR maintenant',
      successDesc_2: 'ou',
      successDesc_3: "ouvrez l'application de bureau WhatsApp",
      successDesc_1_mobile: "WhatsApp devrait s'ouvrir automatiquement",
      successDesc_2_mobile: '',
      successDesc_3_mobile: "Si WhatsApp ne s'est pas ouvert, cliquez sur « Ouvrir WhatsApp »",
      qrCodeInstruction: "Si l'application ne s'est pas chargée automatiquement, scannez le code QR avec votre téléphone ou cliquez sur le bouton ci-dessous.",
      openDesktopBtn: 'Ouvrez WhatsApp',
      acceptedDisclaimerLbl: 'Politique de confidentialité convenue',
    },
  },
  ar:{
    message:{
      applicationSubtitle: 'تقدم الآن',
      applicationSubtitle_ai: 'ابحث عن الوظيفة المناسبة بسهولة مع الذكاء الاصطناعي في واتساب!',
      welComeTitle: 'مرحباً بكم في التطبيق عبر الواتساب',
      step1Title: 'تقدم بطلبك عبر الواتساب',
      step1Desc: 'ابدأ عملية التقديم بالضغط على "التقديم عبر واتساب"',
      step1Title_ai: 'ابحث عن وظيفة باستخدام WhatsApp',
      step1Desc_ai: 'ابدأ البحث عن وظيفة بالضغط على "البحث عن وظيفة باستخدام WhatsApp"',
      step2Title: 'الموافقة على سياسة الخصوصية',
      step2Desc: 'قم بقبول سياسة الخصوصية الخاصة بنا في الصفحة التالية',
      step3Title: 'افتح واتساب',
      step3Desc: 'امسح رمز الاستجابة السريعة أو افتح تطبيق WhatsApp Desktop',
      step3Desc_mobile: 'يفتح الواتس اب تلقائيا',
      step3Desc_ai_mobile: 'يفتح الواتس اب تلقائيا',
      step4Title: 'ابدأ التطبيق في WhatsApp',
      step4Desc: 'أرسل الرسالة المحددة لبدء عملية التقديم',
      step4Title_ai: 'ابحث عن وظيفتك على الواتساب',
      step4Desc_ai: 'أرسل الرسالة المحددة وابدأ المحادثة',
      applyBtn: 'تقدم عبر الواتساب',
      applyBtn_ai: 'ابحث عن وظيفة باستخدام WhatsApp',
      privacyText: 'تعرف على المزيد حول',
      privacyLink: 'سياسة الخصوصية',
      legalText: 'يقرأ',
      legalLink: 'بصمة',
      consentHeader: 'موافقتك مطلوبة',
      agreeBtn: 'أنا موافق',
      successTitle: 'شكرًا لك! ابدأ باستخدام واتساب الآن!',
      successDesc_1: 'امسح رمز الاستجابة السريعة الآن',
      successDesc_2: 'أو',
      successDesc_3: 'افتح تطبيق WhatsApp لسطح المكتب',
      successDesc_1_mobile: 'يجب أن يفتح WhatsApp تلقائيًا',
      successDesc_2_mobile: '',
      successDesc_3_mobile: 'إذا لم يتم فتح WhatsApp، انقر فوق "فتح WhatsApp"',
      qrCodeInstruction: 'إذا لم يتم تحميل التطبيق تلقائيًا، قم بمسح رمز الاستجابة السريعة QR باستخدام هاتفك أو انقر فوق الزر أدناه.',
      openDesktopBtn: 'افتح واتساب',
      acceptedDisclaimerLbl: 'سياسة الخصوصية المتفق عليها',
    },
  },
  fa:{
    message:{
      applicationSubtitle: 'همین حالا درخواست دهید',
      applicationSubtitle_ai: 'با هوش مصنوعی در واتس‌اپ، شغل مناسب خود را به راحتی پیدا کنید!',
      welComeTitle: 'از طریق واتس‌اپ به برنامه خوش آمدید',
      step1Title: 'با واتساپ درخواست دهید',
      step1Desc: 'با کلیک بر روی «درخواست با واتس‌اپ» فرآیند درخواست را آغاز کنید.',
      step1Title_ai: 'با واتس‌اپ شغل پیدا کنید',
      step1Desc_ai: 'جستجوی شغل خود را با کلیک روی «یافتن شغل با واتس‌اپ» آغاز کنید',
      step2Title: 'موافقت با سیاست حفظ حریم خصوصی',
      step2Desc: 'سیاست حفظ حریم خصوصی ما را در صفحه بعد بپذیرید',
      step3Title: 'واتساپ را باز کنید',
      step3Desc: 'کد QR را اسکن کنید یا واتساپ دسکتاپ را باز کنید',
      step3Desc_mobile: 'واتس‌اپ به صورت خودکار باز می‌شود',
      step3Desc_ai_mobile: 'واتس‌اپ به صورت خودکار باز می‌شود',
      step4Title: 'برنامه را در واتس‌اپ اجرا کنید',
      step4Desc: 'برای شروع فرآیند درخواست، پیام تعیین‌شده را ارسال کنید',
      step4Title_ai: 'شغل مورد نظر خود را در واتس‌اپ پیدا کنید',
      step4Desc_ai: 'پیام تجویز شده را ارسال کنید و مکالمه را شروع کنید',
      applyBtn: 'از طریق واتس‌اپ اقدام کنید',
      applyBtn_ai: 'با واتس‌اپ شغل پیدا کنید',
      privacyText: 'درباره ما بیشتر بدانید',
      privacyLink: 'سیاست حفظ حریم خصوصی',
      legalText: 'بخوانید',
      legalLink: 'اثر انگشت',
      consentHeader: 'رضایت شما لازم است',
      agreeBtn: 'موافقم',
      successTitle: 'ممنون! همین حالا استفاده از واتساپ را شروع کنید!',
      successDesc_1: 'همین حالا کد QR را اسکن کنید',
      successDesc_2: 'یا',
      successDesc_3: 'برنامه دسکتاپ واتس‌اپ را باز کنید',
      successDesc_1_mobile: 'واتساپ باید به طور خودکار باز شود',
      successDesc_2_mobile: '',
      successDesc_3_mobile: 'اگر واتس‌اپ باز نشده است، روی «باز کردن واتس‌اپ» کلیک کنید.',
      qrCodeInstruction: 'اگر برنامه به طور خودکار بارگیری نشد، کد QR را با تلفن خود اسکن کنید یا روی دکمه زیر کلیک کنید.',
      openDesktopBtn: 'واتساپ را باز کنید',
      acceptedDisclaimerLbl: 'سیاست حفظ حریم خصوصی توافق شده',
    },
  },
  ro:{
    message:{
      applicationSubtitle: 'Aplică acum',
      applicationSubtitle_ai: 'Găsește ușor jobul potrivit cu inteligența artificială pe WhatsApp!',
      welComeTitle: 'Bine ați venit în aplicație prin WhatsApp',
      step1Title: 'Aplică prin WhatsApp',
      step1Desc: 'Începeți procesul de aplicare dând clic pe „Aplicați cu WhatsApp”',
      step1Title_ai: 'Găsește un loc de muncă cu WhatsApp',
      step1Desc_ai: 'Începeți căutarea unui loc de muncă dând clic pe „Găsește un loc de muncă cu WhatsApp”',
      step2Title: 'Sunt de acord cu politica de confidențialitate',
      step2Desc: 'Acceptați politica noastră de confidențialitate pe pagina următoare',
      step3Title: 'Deschide WhatsApp',
      step3Desc: 'Scanează codul QR sau deschide WhatsApp Desktop',
      step3Desc_mobile: 'WhatsApp se deschide automat',
      step3Desc_ai_mobile: 'WhatsApp se deschide automat',
      step4Title: 'Porniți aplicația în WhatsApp',
      step4Desc: 'Trimiteți mesajul prescris pentru a începe procesul de aplicare',
      step4Title_ai: 'Găsește-ți jobul pe WhatsApp',
      step4Desc_ai: 'Trimite mesajul prescris și începe conversația',
      applyBtn: 'Aplicați prin WhatsApp',
      applyBtn_ai: 'Găsește un loc de muncă cu WhatsApp',
      privacyText: 'Află mai multe despre',
      privacyLink: 'Politica de confidențialitate',
      legalText: 'Citire',
      legalLink: 'imprima',
      consentHeader: 'Este necesar consimțământul dumneavoastră',
      agreeBtn: 'Sunt de acord',
      successTitle: 'Mulțumesc! Începe să folosești WhatsApp acum!',
      successDesc_1: 'Scanează codul QR acum',
      successDesc_2: 'sau',
      successDesc_3: 'deschide aplicația WhatsApp pentru desktop',
      successDesc_1_mobile: 'WhatsApp ar trebui să se deschidă automat',
      successDesc_2_mobile: '',
      successDesc_3_mobile: 'Dacă WhatsApp nu s-a deschis, faceți clic pe „Deschide WhatsApp”',
      qrCodeInstruction: 'Dacă aplicația nu s-a încărcat automat, scanați codul QR cu telefonul sau faceți clic pe butonul de mai jos.',
      openDesktopBtn: 'Deschide WhatsApp',
      acceptedDisclaimerLbl: 'Politica de confidențialitate convenită',
    },
  },
  it:{
    message:{
      applicationSubtitle: 'Candidati ora',
      applicationSubtitle_ai: "Trova facilmente il lavoro giusto con l'intelligenza artificiale di WhatsApp!",
      welComeTitle: "Benvenuti all'applicazione tramite WhatsApp",
      step1Title: 'Candidati con WhatsApp',
      step1Desc: 'Avvia la procedura di candidatura cliccando su "Candidati con WhatsApp"',
      step1Title_ai: 'Trova lavoro con WhatsApp',
      step1Desc_ai: 'Inizia la tua ricerca di lavoro cliccando su "Trova lavoro con WhatsApp"',
      step2Title: "Accetto l'informativa sulla privacy",
      step2Desc: 'Accetta la nostra politica sulla privacy nella pagina successiva',
      step3Title: 'Apri WhatsApp',
      step3Desc: 'Scansiona il codice QR o apri WhatsApp Desktop',
      step3Desc_mobile: 'WhatsApp si apre automaticamente',
      step3Desc_ai_mobile: 'WhatsApp si apre automaticamente',
      step4Title: "Avvia l'applicazione su WhatsApp",
      step4Desc: 'Invia il messaggio prescritto per avviare la procedura di richiesta',
      step4Title_ai: 'Trova il tuo lavoro su WhatsApp',
      step4Desc_ai: 'Invia il messaggio prescritto e inizia la conversazione',
      applyBtn: 'Candidati tramite WhatsApp',
      applyBtn_ai: 'Trova lavoro con WhatsApp',
      privacyText: 'Scopri di più su',
      privacyLink: 'politica sulla riservatezza',
      legalText: 'Leggere',
      legalLink: 'impronta',
      consentHeader: 'Il tuo consenso è richiesto',
      agreeBtn: "Sono d'accordo",
      successTitle: 'Grazie! Inizia subito a usare WhatsApp!',
      successDesc_1: 'Scansiona subito il codice QR',
      successDesc_2: 'O',
      successDesc_3: "apri l'app desktop di WhatsApp",
      successDesc_1_mobile: 'WhatsApp dovrebbe aprirsi automaticamente',
      successDesc_2_mobile: '',
      successDesc_3_mobile: 'Se WhatsApp non si è aperto, clicca su "Apri WhatsApp"',
      qrCodeInstruction: "Se l'applicazione non si carica automaticamente, scansiona il codice QR con il tuo telefono o clicca sul pulsante qui sotto.",
      openDesktopBtn: 'Apri WhatsApp',
      acceptedDisclaimerLbl: 'Informativa sulla privacy accettata',
    },
  },
  es:{
    message:{
      applicationSubtitle: 'Aplicar ahora',
      applicationSubtitle_ai: '¡Encuentra el trabajo adecuado fácilmente con IA en WhatsApp!',
      welComeTitle: 'Bienvenido a la aplicación vía WhatsApp',
      step1Title: 'Aplicar con WhatsApp',
      step1Desc: 'Inicie el proceso de solicitud haciendo clic en "Aplicar con WhatsApp"',
      step1Title_ai: 'Encuentra trabajo con WhatsApp',
      step1Desc_ai: 'Comienza tu búsqueda de empleo haciendo clic en "Buscar trabajo con WhatsApp"',
      step2Title: 'Aceptar la política de privacidad',
      step2Desc: 'Acepte nuestra política de privacidad en la página siguiente',
      step3Title: 'Abrir WhatsApp',
      step3Desc: 'Escanea el código QR o abre WhatsApp Desktop',
      step3Desc_mobile: 'WhatsApp se abre automáticamente',
      step3Desc_ai_mobile: 'WhatsApp se abre automáticamente',
      step4Title: 'Iniciar la aplicación en WhatsApp',
      step4Desc: 'Envíe el mensaje prescrito para iniciar el proceso de solicitud',
      step4Title_ai: 'Encuentra tu trabajo en WhatsApp',
      step4Desc_ai: 'Envía el mensaje prescrito e inicia la conversación.',
      applyBtn: 'Aplicar vía WhatsApp',
      applyBtn_ai: 'Encuentra trabajo con WhatsApp',
      privacyText: 'Obtenga más información sobre',
      privacyLink: 'política de privacidad',
      legalText: 'Leer',
      legalLink: 'imprimir',
      consentHeader: 'Se requiere su consentimiento',
      agreeBtn: 'Estoy de acuerdo',
      successTitle: '¡Gracias! ¡Empieza a usar WhatsApp ya!',
      successDesc_1: 'Escanee el código QR ahora',
      successDesc_2: 'o',
      successDesc_3: 'Abra la aplicación de escritorio de WhatsApp',
      successDesc_1_mobile: 'WhatsApp debería abrirse automáticamente',
      successDesc_2_mobile: '',
      successDesc_3_mobile: 'Si WhatsApp no se ha abierto, haga clic en "Abrir WhatsApp"',
      qrCodeInstruction: 'Si la aplicación no se cargó automáticamente, escanee el código QR con su teléfono o haga clic en el botón a continuación.',
      openDesktopBtn: 'Abrir WhatsApp',
      acceptedDisclaimerLbl: 'Política de privacidad acordada',
    },
  },
  bg:{
    message:{
      applicationSubtitle: 'Кандидатствайте сега',
      applicationSubtitle_ai: 'Намерете лесно правилната работа с изкуствен интелект в WhatsApp!',
      welComeTitle: 'Добре дошли в приложението чрез WhatsApp',
      step1Title: 'Кандидатствайте с WhatsApp',
      step1Desc: 'Започнете процеса на кандидатстване, като кликнете върху „Кандидатстване с WhatsApp“',
      step1Title_ai: 'Намерете работа с WhatsApp',
      step1Desc_ai: 'Започнете търсенето си на работа, като кликнете върху „Намерете работа с WhatsApp“',
      step2Title: 'Съгласен съм с политиката за поверителност',
      step2Desc: 'Приемете нашата политика за поверителност на следващата страница',
      step3Title: 'Отворете WhatsApp',
      step3Desc: 'Сканирайте QR кода или отворете WhatsApp Desktop',
      step3Desc_mobile: 'WhatsApp се отваря автоматично',
      step3Desc_ai_mobile: 'WhatsApp се отваря автоматично',
      step4Title: 'Стартирайте приложението в WhatsApp',
      step4Desc: 'Изпратете предписаното съобщение, за да започнете процеса на кандидатстване',
      step4Title_ai: 'Намерете работата си в WhatsApp',
      step4Desc_ai: 'Изпратете предписаното съобщение и започнете разговора',
      applyBtn: 'Кандидатствайте чрез WhatsApp',
      applyBtn_ai: 'Намерете работа с WhatsApp',
      privacyText: 'Научете повече за',
      privacyLink: 'Политика за поверителност',
      legalText: 'Прочетете',
      legalLink: 'отпечатък',
      consentHeader: 'Необходимо е вашето съгласие',
      agreeBtn: 'Съгласен съм',
      successTitle: 'Благодаря! Започнете да използвате WhatsApp сега!',
      successDesc_1: 'Сканирайте QR кода сега',
      successDesc_2: 'или',
      successDesc_3: 'отворете настолното приложение WhatsApp',
      successDesc_1_mobile: 'WhatsApp трябва да се отвори автоматично',
      successDesc_2_mobile: '',
      successDesc_3_mobile: 'Ако WhatsApp не се е отворил, кликнете върху „Отвори WhatsApp“',
      qrCodeInstruction: 'Ако приложението не се зареди автоматично, сканирайте QR кода с телефона си или кликнете върху бутона по-долу.',
      openDesktopBtn: 'Отворете WhatsApp',
      acceptedDisclaimerLbl: 'Договорена политика за поверителност',
    },
  },
  pl:{
    message:{
      applicationSubtitle: 'Złóż wniosek teraz',
      applicationSubtitle_ai: 'Znajdź odpowiednią pracę łatwo dzięki sztucznej inteligencji w WhatsApp!',
      welComeTitle: 'Witamy w aplikacji przez WhatsApp',
      step1Title: 'Aplikuj przez WhatsApp',
      step1Desc: 'Rozpocznij proces aplikacji, klikając „Aplikuj przez WhatsApp”',
      step1Title_ai: 'Znajdź pracę za pomocą WhatsApp',
      step1Desc_ai: 'Rozpocznij poszukiwania pracy, klikając „Znajdź pracę przez WhatsApp”',
      step2Title: 'Zgadzam się z polityką prywatności',
      step2Desc: 'Zaakceptuj naszą politykę prywatności na następnej stronie',
      step3Title: 'Otwórz WhatsApp',
      step3Desc: 'Zeskanuj kod QR lub otwórz WhatsApp Desktop',
      step3Desc_mobile: 'WhatsApp otwiera się automatycznie',
      step3Desc_ai_mobile: 'WhatsApp otwiera się automatycznie',
      step4Title: 'Uruchom aplikację w WhatsApp',
      step4Desc: 'Aby rozpocząć proces składania wniosku, wyślij wymaganą wiadomość',
      step4Title_ai: 'Znajdź swoją pracę na WhatsAppie',
      step4Desc_ai: 'Wyślij zaleconą wiadomość i rozpocznij rozmowę',
      applyBtn: 'Złóż wniosek przez WhatsApp',
      applyBtn_ai: 'Znajdź pracę za pomocą WhatsApp',
      privacyText: 'Dowiedz się więcej o',
      privacyLink: 'Polityka prywatności',
      legalText: 'Czytać',
      legalLink: 'odcisk',
      consentHeader: 'Wymagana jest Twoja zgoda',
      agreeBtn: 'Zgadzam się',
      successTitle: 'Dziękujemy! Zacznij korzystać z WhatsApp już teraz!',
      successDesc_1: 'Zeskanuj kod QR teraz',
      successDesc_2: 'Lub',
      successDesc_3: 'otwórz aplikację WhatsApp na komputerze',
      successDesc_1_mobile: 'WhatsApp powinien otworzyć się automatycznie',
      successDesc_2_mobile: '',
      successDesc_3_mobile: 'Jeśli WhatsApp się nie otworzył, kliknij „Otwórz WhatsApp”',
      qrCodeInstruction: 'Jeśli aplikacja nie załadowała się automatycznie, zeskanuj kod QR za pomocą telefonu lub kliknij poniższy przycisk.',
      openDesktopBtn: 'Otwórz WhatsApp',
      acceptedDisclaimerLbl: 'Uzgodniona polityka prywatności',
    },
  },
  el:{
    message:{
      applicationSubtitle: 'Κάντε αίτηση τώρα',
      applicationSubtitle_ai: 'Βρείτε εύκολα την κατάλληλη δουλειά με την Τεχνητή Νοημοσύνη στο WhatsApp!',
      welComeTitle: 'Καλώς ορίσατε στην εφαρμογή μέσω WhatsApp',
      step1Title: 'Κάντε αίτηση μέσω WhatsApp',
      step1Desc: 'Ξεκινήστε τη διαδικασία αίτησης κάνοντας κλικ στην επιλογή "Υποβολή αίτησης μέσω WhatsApp"',
      step1Title_ai: 'Βρείτε δουλειά με το WhatsApp',
      step1Desc_ai: 'Ξεκινήστε την αναζήτηση εργασίας κάνοντας κλικ στην επιλογή «Βρείτε μια εργασία με το WhatsApp»',
      step2Title: 'Συμφωνώ με την πολιτική απορρήτου',
      step2Desc: 'Αποδεχτείτε την πολιτική απορρήτου μας στην επόμενη σελίδα',
      step3Title: 'Άνοιγμα WhatsApp',
      step3Desc: 'Σαρώστε τον κωδικό QR ή ανοίξτε το WhatsApp για υπολογιστή',
      step3Desc_mobile: 'Το WhatsApp ανοίγει αυτόματα',
      step3Desc_ai_mobile: 'Το WhatsApp ανοίγει αυτόματα',
      step4Title: 'Ξεκινήστε την εφαρμογή στο WhatsApp',
      step4Desc: 'Στείλτε το προβλεπόμενο μήνυμα για να ξεκινήσει η διαδικασία υποβολής αίτησης',
      step4Title_ai: 'Βρείτε την εργασία σας στο WhatsApp',
      step4Desc_ai: 'Στείλτε το προκαθορισμένο μήνυμα και ξεκινήστε τη συζήτηση',
      applyBtn: 'Κάντε αίτηση μέσω WhatsApp',
      applyBtn_ai: 'Βρείτε δουλειά με το WhatsApp',
      privacyText: 'Μάθετε περισσότερα για',
      privacyLink: 'Πολιτική Απορρήτου',
      legalText: 'Ανάγνωση',
      legalLink: 'αποτύπωμα',
      consentHeader: 'Απαιτείται η συγκατάθεσή σας',
      agreeBtn: 'Συμφωνώ',
      successTitle: 'Ευχαριστώ! Ξεκινήστε να χρησιμοποιείτε το WhatsApp τώρα!',
      successDesc_1: 'Σαρώστε τον κωδικό QR τώρα',
      successDesc_2: 'ή',
      successDesc_3: 'ανοίξτε την εφαρμογή WhatsApp για υπολογιστές',
      successDesc_1_mobile: 'Το WhatsApp θα πρέπει να ανοίγει αυτόματα',
      successDesc_2_mobile: '',
      successDesc_3_mobile: 'Εάν το WhatsApp δεν έχει ανοίξει, κάντε κλικ στο "Άνοιγμα WhatsApp"',
      qrCodeInstruction: 'Εάν η εφαρμογή δεν φορτώθηκε αυτόματα, σαρώστε τον κωδικό QR με το τηλέφωνό σας ή κάντε κλικ στο παρακάτω κουμπί.',
      openDesktopBtn: 'Άνοιγμα WhatsApp',
      acceptedDisclaimerLbl: 'Συμφωνημένη πολιτική απορρήτου',
    },
  },
  ru:{
    message:{
      applicationSubtitle: 'Подать заявку сейчас',
      applicationSubtitle_ai: 'Найдите подходящую работу легко с помощью ИИ в WhatsApp!',
      welComeTitle: 'Добро пожаловать в приложение через WhatsApp',
      step1Title: 'Подать заявку через WhatsApp',
      step1Desc: 'Начните процесс подачи заявки, нажав «Подать заявку через WhatsApp».',
      step1Title_ai: 'Найдите работу с WhatsApp',
      step1Desc_ai: 'Начните поиск работы, нажав «Найти работу в WhatsApp».',
      step2Title: 'Согласен с политикой конфиденциальности',
      step2Desc: 'Примите нашу политику конфиденциальности на следующей странице.',
      step3Title: 'Откройте WhatsApp',
      step3Desc: 'Отсканируйте QR-код или откройте WhatsApp Desktop',
      step3Desc_mobile: 'WhatsApp открывается автоматически',
      step3Desc_ai_mobile: 'WhatsApp открывается автоматически',
      step4Title: 'Запустите приложение в WhatsApp',
      step4Desc: 'Отправьте предписанное сообщение, чтобы начать процесс подачи заявления.',
      step4Title_ai: 'Найдите работу в WhatsApp',
      step4Desc_ai: 'Отправьте предписанное сообщение и начните разговор.',
      applyBtn: 'Подать заявку через WhatsApp',
      applyBtn_ai: 'Найдите работу с WhatsApp',
      privacyText: 'Узнать больше о',
      privacyLink: 'политика конфиденциальности',
      legalText: 'Читать',
      legalLink: 'отпечаток',
      consentHeader: 'Требуется ваше согласие.',
      agreeBtn: 'Я согласен',
      successTitle: 'Спасибо! Начните использовать WhatsApp прямо сейчас!',
      successDesc_1: 'Отсканируйте QR-код сейчас',
      successDesc_2: 'или',
      successDesc_3: 'откройте приложение WhatsApp для ПК',
      successDesc_1_mobile: 'WhatsApp должен открываться автоматически.',
      successDesc_2_mobile: '',
      successDesc_3_mobile: 'Если WhatsApp не открылся, нажмите «Открыть WhatsApp».',
      qrCodeInstruction: 'Если приложение не загрузилось автоматически, отсканируйте QR-код с помощью телефона или нажмите кнопку ниже.',
      openDesktopBtn: 'Откройте WhatsApp',
      acceptedDisclaimerLbl: 'Согласованная политика конфиденциальности',
    },
  },
  hu:{
    message:{
      applicationSubtitle: 'Jelentkezz most',
      applicationSubtitle_ai: 'Találd meg a megfelelő állást könnyedén a WhatsApp mesterséges intelligenciájával!',
      welComeTitle: 'Üdvözöljük a WhatsApp-on keresztüli alkalmazásban',
      step1Title: 'Jelentkezés WhatsApp-on keresztül',
      step1Desc: 'A jelentkezési folyamatot a „Jelentkezés WhatsApp-on” gombra kattintva indíthatod el.',
      step1Title_ai: 'Álláskeresés WhatsApp-on',
      step1Desc_ai: 'Indítsd el az álláskeresést a „Munkakeresés WhatsApp-on” gombra kattintva.',
      step2Title: 'Elfogadom az adatvédelmi irányelveket',
      step2Desc: 'Fogadja el adatvédelmi irányelveinket a következő oldalon',
      step3Title: 'Nyisd meg a WhatsAppot',
      step3Desc: 'Olvasd be a QR-kódot, vagy nyisd meg a WhatsApp asztali alkalmazást',
      step3Desc_mobile: 'A WhatsApp automatikusan megnyílik',
      step3Desc_ai_mobile: 'A WhatsApp automatikusan megnyílik',
      step4Title: 'Indítsd el az alkalmazást a WhatsApp-ban',
      step4Desc: 'Küldd el az előírt üzenetet a jelentkezési folyamat megkezdéséhez',
      step4Title_ai: 'Találd meg a munkádat a WhatsApp-on',
      step4Desc_ai: 'Küldd el a megadott üzenetet, és kezdd el a beszélgetést',
      applyBtn: 'Jelentkezés WhatsApp-on keresztül',
      applyBtn_ai: 'Álláskeresés WhatsApp-on',
      privacyText: 'Tudjon meg többet a következőről:',
      privacyLink: 'Adatvédelmi irányelvek',
      legalText: 'Olvas',
      legalLink: 'lenyomat',
      consentHeader: 'Az Ön hozzájárulása szükséges',
      agreeBtn: 'Egyetértek',
      successTitle: 'Köszönöm! Kezdd el használni a WhatsAppot most!',
      successDesc_1: 'Olvasd be a QR-kódot most',
      successDesc_2: 'vagy',
      successDesc_3: 'nyisd meg a WhatsApp asztali alkalmazást',
      successDesc_1_mobile: 'A WhatsAppnak automatikusan meg kell nyílnia',
      successDesc_2_mobile: '',
      successDesc_3_mobile: 'Ha a WhatsApp nem nyílt meg, kattintson a „WhatsApp megnyitása” gombra.',
      qrCodeInstruction: 'Ha az alkalmazás nem töltődik be automatikusan, olvassa be a QR-kódot a telefonjával, vagy kattintson az alábbi gombra.',
      openDesktopBtn: 'Nyisd meg a WhatsAppot',
      acceptedDisclaimerLbl: 'Elfogadott adatvédelmi irányelvek',
    },
  },
  uk:{
    message:{
      applicationSubtitle: 'Подати заявку зараз',
      applicationSubtitle_ai: 'Легко знайдіть потрібну роботу за допомогою штучного інтелекту в WhatsApp!',
      welComeTitle: 'Ласкаво просимо до програми через WhatsApp',
      step1Title: 'Подати заявку через WhatsApp',
      step1Desc: 'Розпочніть процес подачі заявки, натиснувши кнопку «Подати заявку через WhatsApp»',
      step1Title_ai: 'Знайдіть роботу за допомогою WhatsApp',
      step1Desc_ai: 'Розпочніть пошук роботи, натиснувши кнопку «Знайти роботу за допомогою WhatsApp»',
      step2Title: 'Погоджуюся з політикою конфіденційності',
      step2Desc: 'Прийміть нашу політику конфіденційності на наступній сторінці',
      step3Title: 'Відкрийте WhatsApp',
      step3Desc: 'Відскануйте QR-код або відкрийте WhatsApp для комп’ютера',
      step3Desc_mobile: 'WhatsApp відкривається автоматично',
      step3Desc_ai_mobile: 'WhatsApp відкривається автоматично',
      step4Title: 'Запустіть додаток у WhatsApp',
      step4Desc: 'Надішліть зазначене повідомлення, щоб розпочати процес подання заявки',
      step4Title_ai: 'Знайдіть свою роботу в WhatsApp',
      step4Desc_ai: 'Надішліть запропоноване повідомлення та розпочніть розмову',
      applyBtn: 'Подати заявку через WhatsApp',
      applyBtn_ai: 'Знайдіть роботу за допомогою WhatsApp',
      privacyText: 'Дізнайтеся більше про',
      privacyLink: 'Політика конфіденційності',
      legalText: 'Читати',
      legalLink: 'вихідний матеріал',
      consentHeader: 'Ваша згода потрібна',
      agreeBtn: 'Я погоджуюся',
      successTitle: 'Дякую! Почніть користуватися WhatsApp зараз!',
      successDesc_1: 'Відскануйте QR-код зараз',
      successDesc_2: 'або',
      successDesc_3: 'відкрийте настільний додаток WhatsApp',
      successDesc_1_mobile: 'WhatsApp має відкриватися автоматично',
      successDesc_2_mobile: '',
      successDesc_3_mobile: 'Якщо WhatsApp не відкрився, натисніть «Відкрити WhatsApp»',
      qrCodeInstruction: 'Якщо програма не завантажилася автоматично, відскануйте QR-код за допомогою телефону або натисніть кнопку нижче.',
      openDesktopBtn: 'Відкрийте WhatsApp',
      acceptedDisclaimerLbl: 'Узгоджена політика конфіденційності',
    },
  },
  nl:{
    message:{
      applicationSubtitle: 'Solliciteer nu',
      applicationSubtitle_ai: 'Vind eenvoudig de juiste baan met AI in WhatsApp!',
      welComeTitle: 'Welkom bij de applicatie via WhatsApp',
      step1Title: 'Solliciteer met WhatsApp',
      step1Desc: 'Start het sollicitatieproces door te klikken op "Solliciteren met WhatsApp"',
      step1Title_ai: 'Vind een baan met WhatsApp',
      step1Desc_ai: 'Start je zoektocht naar een baan door te klikken op "Vind een baan met WhatsApp"',
      step2Title: 'Akkoord gaan met het privacybeleid',
      step2Desc: 'Accepteer ons privacybeleid op de volgende pagina',
      step3Title: 'WhatsApp openen',
      step3Desc: 'Scan de QR-code of open WhatsApp Desktop',
      step3Desc_mobile: 'WhatsApp opent automatisch',
      step3Desc_ai_mobile: 'WhatsApp opent automatisch',
      step4Title: 'Start de applicatie in WhatsApp',
      step4Desc: 'Stuur het voorgeschreven bericht om het aanvraagproces te starten',
      step4Title_ai: 'Vind je baan op WhatsApp',
      step4Desc_ai: 'Stuur het voorgeschreven bericht en begin het gesprek',
      applyBtn: 'Solliciteer via WhatsApp',
      applyBtn_ai: 'Vind een baan met WhatsApp',
      privacyText: 'Meer informatie over',
      privacyLink: 'Privacybeleid',
      legalText: 'Lezen',
      legalLink: 'afdruk',
      consentHeader: 'Uw toestemming is vereist',
      agreeBtn: 'Ik ben het ermee eens',
      successTitle: 'Bedankt! Begin nu met WhatsApp te gebruiken!',
      successDesc_1: 'Scan nu de QR-code',
      successDesc_2: 'of',
      successDesc_3: 'open de WhatsApp-desktopapp',
      successDesc_1_mobile: 'WhatsApp zou automatisch moeten openen',
      successDesc_2_mobile: '',
      successDesc_3_mobile: 'Als WhatsApp niet geopend is, klik dan op "WhatsApp openen"',
      qrCodeInstruction: 'Als de applicatie niet automatisch wordt geladen, scan dan de QR-code met uw telefoon of klik op de onderstaande knop.',
      openDesktopBtn: 'WhatsApp openen',
      acceptedDisclaimerLbl: 'Akkoord privacybeleid',
    },
  },
  tr:{
    message:{
      applicationSubtitle: 'Şimdi başvurun',
      applicationSubtitle_ai: "WhatsApp'ta yapay zeka ile doğru işi kolayca bulun!",
      welComeTitle: 'WhatsApp üzerinden uygulamaya hoş geldiniz',
      step1Title: 'WhatsApp ile başvurun',
      step1Desc: '"WhatsApp ile Başvur" butonuna tıklayarak başvuru sürecini başlatın',
      step1Title_ai: 'WhatsApp ile iş bulun',
      step1Desc_ai: '"WhatsApp ile iş bul" butonuna tıklayarak iş aramaya başlayın',
      step2Title: 'Gizlilik politikasını kabul edin',
      step2Desc: 'Bir sonraki sayfada gizlilik politikamızı kabul edin',
      step3Title: "WhatsApp'ı açın",
      step3Desc: 'QR kodunu tarayın veya WhatsApp Masaüstünü açın',
      step3Desc_mobile: 'WhatsApp otomatik olarak açılıyor',
      step3Desc_ai_mobile: 'WhatsApp otomatik olarak açılıyor',
      step4Title: "Uygulamayı WhatsApp'ta başlatın",
      step4Desc: 'Başvuru sürecini başlatmak için belirtilen mesajı gönderin',
      step4Title_ai: "WhatsApp'ta işinizi bulun",
      step4Desc_ai: 'Belirlenen mesajı gönderin ve sohbeti başlatın',
      applyBtn: 'WhatsApp üzerinden başvurun',
      applyBtn_ai: 'WhatsApp ile iş bulun',
      privacyText: 'Daha fazlasını öğrenin',
      privacyLink: 'Gizlilik Politikası',
      legalText: 'Okumak',
      legalLink: 'baskı',
      consentHeader: 'Onayınız gereklidir',
      agreeBtn: 'Kabul ediyorum',
      successTitle: "Teşekkürler! Hemen WhatsApp'ı kullanmaya başlayın!",
      successDesc_1: 'QR kodunu şimdi tarayın',
      successDesc_2: 'veya',
      successDesc_3: 'WhatsApp masaüstü uygulamasını açın',
      successDesc_1_mobile: 'WhatsApp otomatik olarak açılmalıdır',
      successDesc_2_mobile: '',
      successDesc_3_mobile: "WhatsApp açılmadıysa 'WhatsApp'ı Aç'a tıklayın",
      qrCodeInstruction: 'Uygulama otomatik olarak yüklenmediyse QR kodunu telefonunuzla tarayın veya aşağıdaki butona tıklayın.',
      openDesktopBtn: "WhatsApp'ı açın",
      acceptedDisclaimerLbl: 'Kabul edilen gizlilik politikası',
    },
  },
  sk:{
    message:{
      applicationSubtitle: 'Prihlásiť sa teraz',
      applicationSubtitle_ai: 'Nájdite si tú správnu prácu jednoducho s umelou inteligenciou v WhatsApp!',
      welComeTitle: 'Vitajte v aplikácii cez WhatsApp',
      step1Title: 'Požiadajte si cez WhatsApp',
      step1Desc: 'Spustite proces podávania žiadostí kliknutím na tlačidlo „Požiadať cez WhatsApp“',
      step1Title_ai: 'Nájdite si prácu cez WhatsApp',
      step1Desc_ai: 'Začnite hľadať prácu kliknutím na tlačidlo „Nájsť prácu cez WhatsApp“',
      step2Title: 'Súhlasím so zásadami ochrany osobných údajov',
      step2Desc: 'Prijmite naše zásady ochrany osobných údajov na ďalšej stránke',
      step3Title: 'Otvorte WhatsApp',
      step3Desc: 'Naskenujte QR kód alebo otvorte WhatsApp Desktop',
      step3Desc_mobile: 'WhatsApp sa otvorí automaticky',
      step3Desc_ai_mobile: 'WhatsApp sa otvorí automaticky',
      step4Title: 'Spustite aplikáciu v aplikácii WhatsApp',
      step4Desc: 'Odošlite predpísanú správu na spustenie procesu podávania žiadosti',
      step4Title_ai: 'Nájdite si prácu na WhatsApp',
      step4Desc_ai: 'Odošlite predpísanú správu a začnite konverzáciu',
      applyBtn: 'Prihláste sa cez WhatsApp',
      applyBtn_ai: 'Nájdite si prácu cez WhatsApp',
      privacyText: 'Zistite viac o',
      privacyLink: 'Zásady ochrany osobných údajov',
      legalText: 'Čítať',
      legalLink: 'odtlačok',
      consentHeader: 'Váš súhlas je potrebný',
      agreeBtn: 'Súhlasím',
      successTitle: 'Ďakujem! Začnite používať WhatsApp hneď teraz!',
      successDesc_1: 'Naskenujte QR kód teraz',
      successDesc_2: 'alebo',
      successDesc_3: 'otvorte desktopovú aplikáciu WhatsApp',
      successDesc_1_mobile: 'WhatsApp by sa mal otvoriť automaticky',
      successDesc_2_mobile: '',
      successDesc_3_mobile: 'Ak sa WhatsApp neotvoril, kliknite na „Otvoriť WhatsApp“.',
      qrCodeInstruction: 'Ak sa aplikácia nenačítala automaticky, naskenujte QR kód telefónom alebo kliknite na tlačidlo nižšie.',
      openDesktopBtn: 'Otvorte WhatsApp',
      acceptedDisclaimerLbl: 'Dohodnuté zásady ochrany osobných údajov',
    },
  },
  et:{
    message:{
      applicationSubtitle: 'Kandideeri kohe',
      applicationSubtitle_ai: 'Leia WhatsAppis tehisintellekti abil hõlpsalt sobiv töökoht!',
      welComeTitle: 'Tere tulemast rakendusse WhatsAppi kaudu',
      step1Title: 'Kandideeri WhatsAppi kaudu',
      step1Desc: 'Alusta kandideerimisprotsessi, klõpsates nupul „Kandideeri WhatsAppiga“.',
      step1Title_ai: 'Leia töökoht WhatsAppi abil',
      step1Desc_ai: 'Alusta tööotsingut, klõpsates nupul „Leia töökoht WhatsAppiga“.',
      step2Title: 'Nõustun privaatsuspoliitikaga',
      step2Desc: 'Nõustu meie privaatsuspoliitikaga järgmisel lehel',
      step3Title: 'Ava WhatsApp',
      step3Desc: 'Skanneeri QR-koodi või ava WhatsAppi töölaud',
      step3Desc_mobile: 'WhatsApp avaneb automaatselt',
      step3Desc_ai_mobile: 'WhatsApp avaneb automaatselt',
      step4Title: 'Käivita rakendus WhatsAppis',
      step4Desc: 'Kandideerimisprotsessi alustamiseks saatke ettenähtud sõnum',
      step4Title_ai: 'Leia oma töökoht WhatsAppist',
      step4Desc_ai: 'Saatke ettenähtud sõnum ja alustage vestlust',
      applyBtn: 'Kandideeri WhatsAppi kaudu',
      applyBtn_ai: 'Leia töökoht WhatsAppi abil',
      privacyText: 'Lisateave',
      privacyLink: 'Privaatsuspoliitika',
      legalText: 'Loe',
      legalLink: 'jäljend',
      consentHeader: 'Teie nõusolek on vajalik',
      agreeBtn: 'Ma olen nõus',
      successTitle: 'Aitäh! Hakka kohe WhatsAppi kasutama!',
      successDesc_1: 'Skannige QR-koodi kohe',
      successDesc_2: 'või',
      successDesc_3: 'avage WhatsAppi töölauarakendus',
      successDesc_1_mobile: 'WhatsApp peaks automaatselt avanema',
      successDesc_2_mobile: '',
      successDesc_3_mobile: 'Kui WhatsApp pole veel avanenud, klõpsake nuppu "Ava WhatsApp".',
      qrCodeInstruction: 'Kui rakendus ei laadinud automaatselt, skannige QR-koodi oma telefoniga või klõpsake alloleval nupul.',
      openDesktopBtn: 'Ava WhatsApp',
      acceptedDisclaimerLbl: 'Kokkulepitud privaatsuspoliitika',
    },
  },
  sq: {
    message: {
      applicationSubtitle: 'Apliko tani',
      applicationSubtitle_ai: 'Gjej punën e duhur lehtësisht me anë të inteligjencës artificiale në WhatsApp!',
      welComeTitle: 'Mirë se vini në aplikacionin përmes WhatsApp',
      step1Title: 'Aplikoni me WhatsApp',
      step1Desc: 'Filloni procesin e aplikimit duke klikuar te "Apliko me WhatsApp"',
      step1Title_ai: 'Gjeni një punë me WhatsApp',
      step1Desc_ai: 'Filloni kërkimin tuaj për punë duke klikuar te "Gjeni një punë me WhatsApp"',
      step2Title: 'Pajtohem me politikën e privatësisë',
      step2Desc: 'Pranoni politikën tonë të privatësisë në faqen tjetër',
      step3Title: 'Hap WhatsApp-in',
      step3Desc: 'Skano kodin QR ose hap WhatsApp për desktop',
      step3Desc_mobile: 'WhatsApp hapet automatikisht',
      step3Desc_ai_mobile: 'WhatsApp hapet automatikisht',
      step4Title: 'Hap aplikacionin në WhatsApp',
      step4Desc: 'Dërgoni mesazhin e përshkruar për të filluar procesin e aplikimit',
      step4Title_ai: 'Gjej punën tënde në WhatsApp',
      step4Desc_ai: 'Dërgoni mesazhin e përcaktuar dhe filloni bisedën',
      applyBtn: 'Aplikoni përmes WhatsApp',
      applyBtn_ai: 'Gjeni një punë me WhatsApp',
      privacyText: 'Mëso më shumë rreth',
      privacyLink: 'Politika e Privatësisë',
      legalText: 'Lexo',
      legalLink: 'gjurmë',
      consentHeader: 'Pëlqimi juaj është i nevojshëm',
      agreeBtn: 'Pajtohem',
      successTitle: 'Faleminderit! Filloni të përdorni WhatsApp tani!',
      successDesc_1: 'Skano kodin QR tani',
      successDesc_2: 'ose',
      successDesc_3: 'hap aplikacionin WhatsApp për desktop',
      successDesc_1_mobile: 'WhatsApp duhet të hapet automatikisht',
      successDesc_2_mobile: '',
      successDesc_3_mobile: 'Nëse WhatsApp nuk është hapur, klikoni në "Hap WhatsApp"',
      qrCodeInstruction: 'Nëse aplikacioni nuk është ngarkuar automatikisht, skanoni kodin QR me telefonin tuaj ose klikoni butonin më poshtë.',
      openDesktopBtn: 'Hap WhatsApp-in',
      acceptedDisclaimerLbl: 'Politika e privatësisë e dakordësuar',
    },
  },
  zh: {
    message: {
      applicationSubtitle: '立即申请',
      applicationSubtitle_ai: '使用 WhatsApp 中的 AI 轻松找到合适的工作！',
      welComeTitle: '欢迎通过 WhatsApp 使用应用程序',
      step1Title: '使用 WhatsApp 申请',
      step1Desc: '点击“使用 WhatsApp 申请”开始申请流程',
      step1Title_ai: '使用 WhatsApp 找工作',
      step1Desc_ai: '点击“使用 WhatsApp 找工作”开始您的求职',
      step2Title: '同意隐私政策',
      step2Desc: '在下一页接受我们的隐私政策',
      step3Title: '打开 WhatsApp',
      step3Desc: '扫描二维码或打开 WhatsApp 桌面版',
      step3Desc_mobile: 'WhatsApp 自动打开',
      step3Desc_ai_mobile: 'WhatsApp 自动打开',
      step4Title: '在 WhatsApp 中启动应用程序',
      step4Desc: '发送规定的消息以启动申请流程',
      step4Title_ai: '在 WhatsApp 上寻找您的工作',
      step4Desc_ai: '发送规定的消息并开始对话',
      applyBtn: '通过 WhatsApp 申请',
      applyBtn_ai: '使用 WhatsApp 找工作',
      privacyText: '详细了解',
      privacyLink: '隐私政策',
      legalText: '读',
      legalLink: '印记',
      consentHeader: '需要您的同意',
      agreeBtn: '我同意',
      successTitle: '谢谢！现在就开始使用 WhatsApp 吧！',
      successDesc_1: '立即扫描二维码',
      successDesc_2: '或者',
      successDesc_3: '打开 WhatsApp 桌面应用程序',
      successDesc_1_mobile: 'WhatsApp 应该会自动打开',
      successDesc_2_mobile: '',
      successDesc_3_mobile: '如果 WhatsApp 尚未打开，请点击“打开 WhatsApp”',
      qrCodeInstruction: '如果应用程序未自动加载，请使用手机扫描二维码或单击下面的按钮。',
      openDesktopBtn: '打开 WhatsApp',
      acceptedDisclaimerLbl: '同意隐私政策',
    },
  },
  pt: {
    message: {
      applicationSubtitle: 'Inscreva-se agora',
      applicationSubtitle_ai: 'Encontre o emprego certo facilmente com a IA no WhatsApp!',
      welComeTitle: 'Bem-vindo ao aplicativo via WhatsApp',
      step1Title: 'Inscreva-se com o WhatsApp',
      step1Desc: 'Inicie o processo de inscrição clicando em "Inscreva-se com WhatsApp"',
      step1Title_ai: 'Encontre um emprego com o WhatsApp',
      step1Desc_ai: 'Comece sua busca de emprego clicando em "Encontre um emprego com o WhatsApp"',
      step2Title: 'Concordo com a política de privacidade',
      step2Desc: 'Aceite nossa política de privacidade na próxima página',
      step3Title: 'Abra o WhatsApp',
      step3Desc: 'Escaneie o código QR ou abra o WhatsApp Desktop',
      step3Desc_mobile: 'O WhatsApp abre automaticamente',
      step3Desc_ai_mobile: 'O WhatsApp abre automaticamente',
      step4Title: 'Inicie o aplicativo no WhatsApp',
      step4Desc: 'Envie a mensagem prescrita para iniciar o processo de inscrição',
      step4Title_ai: 'Encontre seu emprego no WhatsApp',
      step4Desc_ai: 'Envie a mensagem prescrita e inicie a conversa',
      applyBtn: 'Inscreva-se via WhatsApp',
      applyBtn_ai: 'Encontre um emprego com o WhatsApp',
      privacyText: 'Saiba mais sobre',
      privacyLink: 'política de Privacidade',
      legalText: 'Ler',
      legalLink: 'imprimir',
      consentHeader: 'Seu consentimento é necessário',
      agreeBtn: 'Concordo',
      successTitle: 'Obrigado! Comece a usar o WhatsApp agora mesmo!',
      successDesc_1: 'Escaneie o código QR agora',
      successDesc_2: 'ou',
      successDesc_3: 'abra o aplicativo WhatsApp para desktop',
      successDesc_1_mobile: 'O WhatsApp deve abrir automaticamente',
      successDesc_2_mobile: '',
      successDesc_3_mobile: 'Se o WhatsApp não abrir, clique em "Abrir WhatsApp"',
      qrCodeInstruction: 'Se o aplicativo não carregar automaticamente, escaneie o código QR com seu telefone ou clique no botão abaixo.',
      openDesktopBtn: 'Abra o WhatsApp',
      acceptedDisclaimerLbl: 'Política de privacidade acordada',
    },
  },
  sr: {
    message: {
      applicationSubtitle: 'Пријавите се сада',
      applicationSubtitle_ai: 'Лако пронађите прави посао уз помоћ вештачке интелигенције у WhatsApp-у!',
      welComeTitle: 'Добродошли у апликацију путем WhatsApp-а',
      step1Title: 'Пријавите се путем WhatsApp-а',
      step1Desc: 'Покрените процес пријаве кликом на „Пријавите се путем WhatsApp-а“',
      step1Title_ai: 'Пронађите посао помоћу WhatsApp-а',
      step1Desc_ai: 'Започните претрагу посла кликом на „Пронађите посао помоћу WhatsApp-а“',
      step2Title: 'Слажем се са политиком приватности',
      step2Desc: 'Прихватите нашу политику приватности на следећој страници',
      step3Title: 'Отвори WhatsApp',
      step3Desc: 'Скенирајте QR код или отворите WhatsApp Desktop',
      step3Desc_mobile: 'WhatsApp се аутоматски отвара',
      step3Desc_ai_mobile: 'WhatsApp се аутоматски отвара',
      step4Title: 'Покрените апликацију у WhatsApp-у',
      step4Desc: 'Пошаљите прописану поруку да бисте започели процес пријаве',
      step4Title_ai: 'Пронађите свој посао на WhatsApp-у',
      step4Desc_ai: 'Пошаљите прописану поруку и започните разговор',
      applyBtn: 'Пријавите се путем WhatsApp-а',
      applyBtn_ai: 'Пронађите посао помоћу WhatsApp-а',
      privacyText: 'Сазнајте више о',
      privacyLink: 'Политика приватности',
      legalText: 'Читај',
      legalLink: 'отисак',
      consentHeader: 'Потребан је ваш пристанак',
      agreeBtn: 'Слажем се',
      successTitle: 'Хвала! Почните да користите WhatsApp сада!',
      successDesc_1: 'Скенирајте QR код сада',
      successDesc_2: 'или',
      successDesc_3: 'отворите WhatsApp апликацију за рачунаре',
      successDesc_1_mobile: 'WhatsApp би требало да се отвори аутоматски',
      successDesc_2_mobile: '',
      successDesc_3_mobile: 'Ако се WhatsApp није отворио, кликните на „Отвори WhatsApp“',
      qrCodeInstruction: 'Ако се апликација није аутоматски учитала, скенирајте QR код телефоном или кликните на дугме испод.',
      openDesktopBtn: 'Отвори WhatsApp',
      acceptedDisclaimerLbl: 'Усклађена политика приватности',
    },
  },
  cs: {
    message: {
      applicationSubtitle: 'Přihlásit se nyní',
      applicationSubtitle_ai: 'Najděte si snadno tu správnou práci s umělou inteligencí ve WhatsAppu!',
      welComeTitle: 'Vítejte v aplikaci přes WhatsApp',
      step1Title: 'Žádost přes WhatsApp',
      step1Desc: 'Zahajte proces podávání žádostí kliknutím na tlačítko „Podat žádost přes WhatsApp“',
      step1Title_ai: 'Najděte si práci s WhatsAppem',
      step1Desc_ai: 'Začněte hledat práci kliknutím na „Najít práci přes WhatsApp“',
      step2Title: 'Souhlasím se zásadami ochrany osobních údajů',
      step2Desc: 'Přijměte naše zásady ochrany osobních údajů na další stránce',
      step3Title: 'Otevřete WhatsApp',
      step3Desc: 'Naskenujte QR kód nebo otevřete WhatsApp Desktop',
      step3Desc_mobile: 'WhatsApp se otevře automaticky',
      step3Desc_ai_mobile: 'WhatsApp se otevře automaticky',
      step4Title: 'Spusťte aplikaci ve WhatsAppu',
      step4Desc: 'Odešlete předepsanou zprávu pro zahájení procesu žádosti',
      step4Title_ai: 'Najděte si práci na WhatsAppu',
      step4Desc_ai: 'Odešlete předepsanou zprávu a zahajte konverzaci',
      applyBtn: 'Žádost přes WhatsApp',
      applyBtn_ai: 'Najděte si práci s WhatsAppem',
      privacyText: 'Zjistěte více o',
      privacyLink: 'Zásady ochrany osobních údajů',
      legalText: 'Číst',
      legalLink: 'otisk',
      consentHeader: 'Váš souhlas je vyžadován',
      agreeBtn: 'Souhlasím',
      successTitle: 'Díky! Začněte používat WhatsApp hned teď!',
      successDesc_1: 'Naskenujte QR kód nyní',
      successDesc_2: 'nebo',
      successDesc_3: 'otevřete desktopovou aplikaci WhatsApp',
      successDesc_1_mobile: 'WhatsApp by se měl otevřít automaticky',
      successDesc_2_mobile: '',
      successDesc_3_mobile: 'Pokud se WhatsApp neotevřel, klikněte na „Otevřít WhatsApp“',
      qrCodeInstruction: 'Pokud se aplikace nenačetla automaticky, naskenujte QR kód telefonem nebo klikněte na tlačítko níže.',
      openDesktopBtn: 'Otevřete WhatsApp',
      acceptedDisclaimerLbl: 'Dohodnuté zásady ochrany osobních údajů',
    },
  },
  be: {
    message: {
      applicationSubtitle: 'Падаць заяўку зараз',
      applicationSubtitle_ai: 'Лёгка знайдзіце патрэбную працу з дапамогай штучнага інтэлекту ў WhatsApp!',
      welComeTitle: 'Сардэчна запрашаем у дадатак праз WhatsApp',
      step1Title: 'Падаць заяўку праз WhatsApp',
      step1Desc: 'Пачніце працэс падачы заяўкі, націснуўшы кнопку «Падаць заяўку праз WhatsApp»',
      step1Title_ai: 'Знайдзіце працу з дапамогай WhatsApp',
      step1Desc_ai: 'Пачніце пошук працы, націснуўшы кнопку «Знайсці працу з дапамогай WhatsApp»',
      step2Title: 'Згадзіцеся з палітыкай прыватнасці',
      step2Desc: 'Прыміце нашу палітыку прыватнасці на наступнай старонцы',
      step3Title: 'Адкрыйце WhatsApp',
      step3Desc: 'Адсканіруйце QR-код або адкрыйце WhatsApp на працоўным стале',
      step3Desc_mobile: 'WhatsApp адкрываецца аўтаматычна',
      step3Desc_ai_mobile: 'WhatsApp адкрываецца аўтаматычна',
      step4Title: 'Запусціце праграму ў WhatsApp',
      step4Desc: 'Адпраўце прадпісанае паведамленне, каб пачаць працэс падачы заяўкі',
      step4Title_ai: 'Знайдзіце сваю працу ў WhatsApp',
      step4Desc_ai: 'Адпраўце загадзя зададзенае паведамленне і пачніце размову',
      applyBtn: 'Падаць заяўку праз WhatsApp',
      applyBtn_ai: 'Знайдзіце працу з дапамогай WhatsApp',
      privacyText: 'Даведайцеся больш пра',
      privacyLink: 'Палітыка прыватнасці',
      legalText: 'Чытаць',
      legalLink: 'выходныя дадзеныя',
      consentHeader: 'Патрабуецца ваша згода',
      agreeBtn: 'Я згодны',
      successTitle: 'Дзякуй! Пачніце карыстацца WhatsApp зараз!',
      successDesc_1: 'Адсканіруйце QR-код зараз',
      successDesc_2: 'або',
      successDesc_3: 'адкрыйце праграму WhatsApp для ПК',
      successDesc_1_mobile: 'WhatsApp павінен адкрыцца аўтаматычна',
      successDesc_2_mobile: '',
      successDesc_3_mobile: 'Калі WhatsApp не адкрыўся, націсніце «Адкрыць WhatsApp»',
      qrCodeInstruction: 'Калі праграма не загрузілася аўтаматычна, адсканіруйце QR-код тэлефонам або націсніце кнопку ніжэй.',
      openDesktopBtn: 'Адкрыйце WhatsApp',
      acceptedDisclaimerLbl: 'Узгодненая палітыка прыватнасці',
    },
  },
  sl: {
    message: {
      applicationSubtitle: 'Prijavi se zdaj',
      applicationSubtitle_ai: 'Z umetno inteligenco v WhatsAppu enostavno poiščite pravo službo!',
      welComeTitle: 'Dobrodošli v aplikaciji prek WhatsAppa',
      step1Title: 'Prijavite se prek WhatsAppa',
      step1Desc: 'Postopek prijave začnite s klikom na »Prijavi se z WhatsApp«.',
      step1Title_ai: 'Poiščite službo z WhatsAppom',
      step1Desc_ai: 'Začnite iskanje zaposlitve s klikom na »Poišči zaposlitev z WhatsApp«',
      step2Title: 'Strinjam se s politiko zasebnosti',
      step2Desc: 'Sprejmite našo politiko zasebnosti na naslednji strani',
      step3Title: 'Odpri WhatsApp',
      step3Desc: 'Skenirajte kodo QR ali odprite WhatsApp Desktop',
      step3Desc_mobile: 'WhatsApp se odpre samodejno',
      step3Desc_ai_mobile: 'WhatsApp se odpre samodejno',
      step4Title: 'Zaženite aplikacijo v WhatsAppu',
      step4Desc: 'Pošljite predpisano sporočilo, da začnete postopek prijave',
      step4Title_ai: 'Poiščite svojo službo na WhatsAppu',
      step4Desc_ai: 'Pošljite predpisano sporočilo in začnite pogovor',
      applyBtn: 'Prijavite se prek WhatsAppa',
      applyBtn_ai: 'Poiščite službo z WhatsAppom',
      privacyText: 'Več o tem',
      privacyLink: 'Pravilnik o zasebnosti',
      legalText: 'Preberi',
      legalLink: 'odtis',
      consentHeader: 'Potrebno je vaše soglasje',
      agreeBtn: 'Strinjam se',
      successTitle: 'Hvala! Začni uporabljati WhatsApp zdaj!',
      successDesc_1: 'Skenirajte QR kodo zdaj',
      successDesc_2: 'ali',
      successDesc_3: 'odprite namizno aplikacijo WhatsApp',
      successDesc_1_mobile: 'WhatsApp bi se moral odpreti samodejno',
      successDesc_2_mobile: '',
      successDesc_3_mobile: 'Če se WhatsApp ni odprl, kliknite »Odpri WhatsApp«',
      qrCodeInstruction: 'Če se aplikacija ni naložila samodejno, skenirajte kodo QR s telefonom ali kliknite spodnji gumb.',
      openDesktopBtn: 'Odpri WhatsApp',
      acceptedDisclaimerLbl: 'Dogovorjena politika zasebnosti',
    },
  },
  bs: {
    message: {
      applicationSubtitle: 'Prijavi se odmah',
      applicationSubtitle_ai: 'Pronađite pravi posao lako uz pomoć umjetne inteligencije u WhatsAppu!',
      welComeTitle: 'Dobrodošli u aplikaciju putem WhatsAppa',
      step1Title: 'Prijavite se putem WhatsAppa',
      step1Desc: 'Započnite proces prijave klikom na "Prijavi se putem WhatsAppa"',
      step1Title_ai: 'Pronađite posao putem WhatsAppa',
      step1Desc_ai: 'Započnite pretragu posla klikom na "Pronađi posao putem WhatsApp-a"',
      step2Title: 'Slažem se s politikom privatnosti',
      step2Desc: 'Prihvatite našu politiku privatnosti na sljedećoj stranici',
      step3Title: 'Otvori WhatsApp',
      step3Desc: 'Skenirajte QR kod ili otvorite WhatsApp Desktop',
      step3Desc_mobile: 'WhatsApp se automatski otvara',
      step3Desc_ai_mobile: 'WhatsApp se automatski otvara',
      step4Title: 'Pokrenite aplikaciju u WhatsAppu',
      step4Desc: 'Pošaljite propisanu poruku da biste započeli proces prijave',
      step4Title_ai: 'Pronađite svoj posao na WhatsAppu',
      step4Desc_ai: 'Pošaljite propisanu poruku i započnite razgovor',
      applyBtn: 'Prijavite se putem WhatsAppa',
      applyBtn_ai: 'Pronađite posao putem WhatsAppa',
      privacyText: 'Saznajte više o',
      privacyLink: 'Politika privatnosti',
      legalText: 'Čitaj',
      legalLink: 'otisak',
      consentHeader: 'Vaš pristanak je potreban',
      agreeBtn: 'Slažem se',
      successTitle: 'Hvala! Počnite koristiti WhatsApp odmah!',
      successDesc_1: 'Skenirajte QR kod sada',
      successDesc_2: 'ili',
      successDesc_3: 'otvorite WhatsApp aplikaciju za računar',
      successDesc_1_mobile: 'WhatsApp bi se trebao automatski otvoriti',
      successDesc_2_mobile: '',
      successDesc_3_mobile: 'Ako se WhatsApp nije otvorio, kliknite na "Otvori WhatsApp"',
      qrCodeInstruction: 'Ako se aplikacija nije automatski učitala, skenirajte QR kod telefonom ili kliknite na dugme ispod.',
      openDesktopBtn: 'Otvori WhatsApp',
      acceptedDisclaimerLbl: 'Dogovorena politika privatnosti',
    },
  },
  th: {
    message: {
      applicationSubtitle: 'สมัครเลยตอนนี้',
      applicationSubtitle_ai: 'ค้นหางานที่ใช่ได้ง่ายๆ ด้วย AI ใน WhatsApp!',
      welComeTitle: 'ยินดีต้อนรับสู่แอปพลิเคชันผ่าน WhatsApp',
      step1Title: 'สมัครผ่าน WhatsApp',
      step1Desc: 'เริ่มขั้นตอนการสมัครโดยคลิกที่ "สมัครด้วย WhatsApp"',
      step1Title_ai: 'ค้นหางานด้วย WhatsApp',
      step1Desc_ai: 'เริ่มการค้นหางานของคุณโดยคลิกที่ "ค้นหางานด้วย WhatsApp"',
      step2Title: 'ยอมรับนโยบายความเป็นส่วนตัว',
      step2Desc: 'ยอมรับนโยบายความเป็นส่วนตัวของเราในหน้าถัดไป',
      step3Title: 'เปิด WhatsApp',
      step3Desc: 'สแกนรหัส QR หรือเปิด WhatsApp Desktop',
      step3Desc_mobile: 'WhatsApp เปิดอัตโนมัติ',
      step3Desc_ai_mobile: 'WhatsApp เปิดอัตโนมัติ',
      step4Title: 'เริ่มต้นการใช้งานแอปพลิเคชันใน WhatsApp',
      step4Desc: 'ส่งข้อความที่กำหนดเพื่อเริ่มขั้นตอนการสมัคร',
      step4Title_ai: 'ค้นหางานของคุณบน WhatsApp',
      step4Desc_ai: 'ส่งข้อความที่กำหนดและเริ่มการสนทนา',
      applyBtn: 'สมัครผ่าน WhatsApp',
      applyBtn_ai: 'ค้นหางานด้วย WhatsApp',
      privacyText: 'เรียนรู้เพิ่มเติมเกี่ยวกับ',
      privacyLink: 'นโยบายความเป็นส่วนตัว',
      legalText: 'อ่าน',
      legalLink: 'รอยประทับ',
      consentHeader: 'จำเป็นต้องได้รับความยินยอมจากคุณ',
      agreeBtn: 'ฉันเห็นด้วย',
      successTitle: 'ขอบคุณ! เริ่มใช้ WhatsApp ทันที!',
      successDesc_1: 'สแกน QR code ได้เลย',
      successDesc_2: 'หรือ',
      successDesc_3: 'เปิดแอป WhatsApp บนเดสก์ท็อป',
      successDesc_1_mobile: 'WhatsApp ควรเปิดโดยอัตโนมัติ',
      successDesc_2_mobile: '',
      successDesc_3_mobile: 'หากยังไม่เปิด WhatsApp ให้คลิกที่ "เปิด WhatsApp"',
      qrCodeInstruction: 'หากแอปพลิเคชันไม่โหลดโดยอัตโนมัติ โปรดสแกนรหัส QR ด้วยโทรศัพท์ของคุณหรือคลิกปุ่มด้านล่าง',
      openDesktopBtn: 'เปิด WhatsApp',
      acceptedDisclaimerLbl: 'ตกลงนโยบายความเป็นส่วนตัว',
    },
  },
  ko: {
    message: {
      applicationSubtitle: '지금 신청하세요',
      applicationSubtitle_ai: 'WhatsApp에서 AI를 이용해 쉽게 적합한 일자리를 찾아보세요!',
      welComeTitle: 'WhatsApp을 통한 애플리케이션에 오신 것을 환영합니다',
      step1Title: 'WhatsApp으로 신청하세요',
      step1Desc: '"WhatsApp으로 신청"을 클릭하여 신청 절차를 시작하세요.',
      step1Title_ai: 'WhatsApp으로 일자리 찾기',
      step1Desc_ai: '"WhatsApp으로 일자리 찾기"를 클릭하여 일자리 검색을 시작하세요.',
      step2Title: '개인정보처리방침에 동의합니다',
      step2Desc: '다음 페이지에서 개인정보 보호정책에 동의하세요',
      step3Title: '왓츠앱을 엽니다',
      step3Desc: 'QR 코드를 스캔하거나 WhatsApp 데스크톱을 엽니다.',
      step3Desc_mobile: 'WhatsApp이 자동으로 열립니다',
      step3Desc_ai_mobile: 'WhatsApp이 자동으로 열립니다',
      step4Title: 'WhatsApp에서 애플리케이션을 시작하세요',
      step4Desc: '신청 절차를 시작하려면 지정된 메시지를 보내세요.',
      step4Title_ai: 'WhatsApp에서 일자리를 찾으세요',
      step4Desc_ai: '지정된 메시지를 보내고 대화를 시작하세요',
      applyBtn: 'WhatsApp으로 신청하세요',
      applyBtn_ai: 'WhatsApp으로 일자리 찾기',
      privacyText: '자세히 알아보세요',
      privacyLink: '개인정보 보호정책',
      legalText: '읽다',
      legalLink: '날인',
      consentHeader: '귀하의 동의가 필요합니다',
      agreeBtn: '나는 동의한다',
      successTitle: '감사합니다! 지금 바로 WhatsApp을 사용해 보세요!',
      successDesc_1: '지금 QR 코드를 스캔하세요',
      successDesc_2: '또는',
      successDesc_3: 'WhatsApp 데스크톱 앱을 엽니다',
      successDesc_1_mobile: 'WhatsApp이 자동으로 열려야 합니다.',
      successDesc_2_mobile: '',
      successDesc_3_mobile: 'WhatsApp이 열리지 않으면 "WhatsApp 열기"를 클릭하세요.',
      qrCodeInstruction: '애플리케이션이 자동으로 로드되지 않으면 휴대폰으로 QR 코드를 스캔하거나 아래 버튼을 클릭하세요.',
      openDesktopBtn: '왓츠앱을 엽니다',
      acceptedDisclaimerLbl: '동의된 개인정보 보호정책',
    },
  },
};

const i18n: I18n = createI18n({
  legacy: false,
  locale: navigator.language.split('-')[0] || 'de',
  fallbackLocale: 'de',
  globalInjection: true,
  messages,
});

export default i18n;
